module.exports = __webpack_public_path__ + "static/media/mushroom_mozza_mobile_hero_fr.bcf8abec.jpg";